import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-offroad-rule',
  templateUrl: './offroad-rule.component.html',
  styleUrls: ['./offroad-rule.component.scss']
})
export class OffroadRuleComponent implements OnInit {
  public monthsList=['Jan','Feb','Mar','Apr','May','Jun','July','Aug','Sep','Oct','Nov','Dec']
  // public month=this.monthsList[0]
  public monthValue = ['00','01', '02', '03', '04','05','06','07','08','09','10','11']
  public month=this.monthValue[0]
  public daysList=['01', '02', '03', '04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31']
  public day=this.daysList[0]
  public weekList = ['00','01', '02', '03', '04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23']
  public weekOneList = ['00','5', '10', '15', '20','25','30','35','40','45','50','55']
  public yearsList=['2022','2023']
  public year=this.yearsList[0]
  public week=this.weekList[0]
 public weekOne=this.weekOneList[0]
  public description=''
  public isCheck=false
  public hours=''
  public isDescErr=false
  public isHoursErr =false
  public offRoadRes:any;
  public globalServicesId = 0;
  public serviceName = '';
  public enabledValue=0;
  public userId='';
  public editServiceId = 0
  public isEdit = false;
  public oneOffResponse:any;
  constructor(private router:Router,private service:ApifirstService) { }

  ngOnInit(): void {
    this.service.globalServicesId.subscribe(data => {
      this.globalServicesId = data
    })
    this.service.serviceName.subscribe(data => {
      this.serviceName = data
    })
    this.service.userId.subscribe(data => {
      this.userId = data
    })
    
    this.service.editServiceId.subscribe(data => {
      this.editServiceId = data
    })
    this.service.oneOffRes.subscribe(data => {
      this.oneOffResponse = data
    this.service.isEditonOff.subscribe(data => {
      this.isEdit = data;
      if (this.isEdit) {
        this.description = this.oneOffResponse.description
        this.day = this.oneOffResponse.weektime
        let time=this.oneOffResponse.configdate.split("-")
        let dayTime=time[2].split(" ")
        let weekTime=dayTime[1].split(":")
        this.year=time[0]
        this.month=time[1]
        if (this.month == "01") {
          this.month="00"
        } else if (this.month == "02") {
          this.month="01"
        } else if (this.month == "03") {
          this.month="02"
        } else if (this.month == "04") {
          this.month="03"
        } else if (this.month == "05") {
          this.month="04"
        } else if (this.month == "06") {
          this.month="05"
        } else if (this.month == "07") {
          this.month="06"
        } else if (this.month == "08") {
          this.month="07"
        } else if (this.month == "09") {
          this.month="08"
        } else if (this.month == "10") {
          this.month="09"
        } else if (this.month == "11") {
          this.month="10"
        } else if (this.month == "12") {
          this.month="11"
        }
        this.day=dayTime[0]
        this.week=weekTime[0]
        this.weekOne=weekTime[1]
        let x :any=this.oneOffResponse.duration_mins/60
        this.hours=x
        if(this.oneOffResponse.enabled == 1){
          this.isCheck =true;
        }else{
          this.isCheck =false;
        }
      }
    })
  
    
    })

    this.service.serviceName.subscribe(data => {
      this.serviceName = data
    })
    this.service.userId.subscribe(data => {
      this.userId = data
    })
    
  }
  
  add(){
    const pattern = new RegExp("^[0-9.]+$");
    if(this.description =="" || this.description == undefined || this.description==null) {
      this.isDescErr=true;
    }else {
      this.isDescErr =false;
    }
    if (this.hours == "" || this.hours == undefined || this.hours == null) {
      this.isHoursErr = true;
    } else if (pattern.test(this.hours)){
      this.isHoursErr = false;
    }
    else {
      this.isHoursErr = true;
    }
    if(this.isCheck){
      this.enabledValue=1
    } else{
      this.enabledValue=0
    }
    var z: number = +this.hours;
    var user: number = +this.userId;
    let req={}
    if (this.isEdit){
      req = {
        "id": this.oneOffResponse.id,
        "serviceid": this.globalServicesId,
        "description": this.description,
        "type": 0,
        "user_id": user,
        "duration_mins": z,
        "enabled": this.enabledValue,
        "recurring": "Oneoff Rule",
        "year":this.year,
        "month":this.month,
        "date":this.day,
        "hour":this.week,
        "min":this.weekOne
      }
      if(!this.isDescErr && !this.isHoursErr){
        this.service.ruleUpdateApi(req).subscribe(data =>{
          this.offRoadRes=data;
          this.service.oneOffRes.next(this.offRoadRes)
          this.service.isEditonOff.next(true);
          this.router.navigate(['admin/showRules']);
        })
    }

    }else {
     req = {
      "serviceid": this.globalServicesId,
      "description": this.description,
      "type": 0,
      "user_id": user,
      "duration_mins": z,
      "enabled": this.enabledValue,
      "recurring": "Oneoff Rule",
      "year":this.year,
      "month":this.month,
      "date":this.day,
      "hour":this.week,
      "min":this.weekOne
    }
    if(!this.isDescErr && !this.isHoursErr){
      this.service.recurringRule(req).subscribe(data =>{
        this.offRoadRes=data;
        this.service.oneOffRes.next(this.offRoadRes)
        this.service.isEditonOff.next(true);
        this.router.navigate(['admin/showRules']);
      })
  }
  }
 
}
  cancel(){
    this.router.navigate(['admin/showRules']);
  }
}
